<div class="w-full">
	<ng-container *ngIf="documents$ | async as documents">
		<div class="flex items-center justify-between">
			<h4 class="mb-0 mr-10">Documents</h4>
			<app-button
				*ngIf="!disabled"
				[icon]="ICON.UPLOAD"
				(click)="openUploadModal()"
				size="small"
				[testHook]="testHooks.UploadDocumentButton"
				>Upload document</app-button
			>
		</div>
		<ng-container *ngIf="documents.length === 0 && !disabled">
			<p *ngIf="type === 'default'" class="mt-2 mr-5">
				Upload any documents for reference
			</p>
			<app-sale-file-upload
				*ngIf="type === 'dropzone'"
				type="dropzone"
				class="justify-self-center self-center w-full h-full"
				[saleId]="matterId"
				[documentType]="TLFileType"
				(success)="onUploadSuccess($event)"
			></app-sale-file-upload>
		</ng-container>
		<div>
			<div
				class="flex justify-between bg-grey-lightest rounded-xl p-3 my-2 cursor-pointer hover:shadow-md"
				*ngFor="let doc of documents"
				(click)="openDocument(doc)"
				[testHook]="testHooks.OpenDocumentDiv"
			>
				<div class="flex items-center flex-1">
					<div
						class="flex items-center justify-center bg-orange-light p-2 rounded-md w-12 h-12"
					>
						<app-icon
							class="text-2xl text-orange-dark"
							[icon]="ICON.DOCUMENT"
						></app-icon>
					</div>
					<div class="flex flex-1 p-3 justify-between">
						<div class="flex flex-col">
							<span class="font-bold">{{ doc?.name }}</span>
							<p class="text-sm">
								Issued on: {{ doc?.uploadedAt | date: 'mediumDate' }}
							</p>
						</div>
						<div class="flex items-center justify-center">
							<app-button
								[icon]="ICON.DELETE"
								btn="secondary"
								[holdable]="true"
								(onClick)="removeDocument(doc)"
								[testHook]="testHooks.DeleteButton"
							></app-button>
						</div>
					</div>
				</div>
			</div>
			<div
				class="flex items-center w-full bg-grey-lightest rounded-xl p-3 my-2 cursor-pointer hover:shadow-md"
				(click)="openForm()"
				*ngIf="showCommercialForm"
				[testHook]="testHooks.OpenFormDiv"
			>
				<div
					class="flex items-center justify-center bg-orange-light p-2 rounded-full w-12 h-12"
				>
					<app-icon
						class="text-2xl text-orange-dark"
						[icon]="ICON.DOCUMENT"
					></app-icon>
				</div>
				<div class="flex flex-1 p-3 justify-between">
					<div class="flex flex-col">
						<span class="font-bold">Commercial policy order form</span>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
</div>
